import React, { useEffect } from "react";
import { Token_Types } from "./UserDtos";
import { useNavigate } from "react-router-dom";

import { RoutesService } from "../Services";

import userServices from "./UserServices";
import { Toast } from "reactstrap";

const UserListner = ({ children }) => {
	const navigate = useNavigate();

	const handleStorageChange = event => {
		// Handle the localStorage change event here

		if (event.storageArea?.getItem(Token_Types.ACCESS_TOKEN)) {
			const isValid = userServices.checkIFValid();
			if (isValid) {
				const user = userServices.getCurrentUser();
				if (user.role) {
					navigate(`${RoutesService.getRoleRoute(user.role)}`);
					return;
				}
				navigate(RoutesService.getLoginRoute());
			} else {
				navigate(RoutesService.getLoginRoute());
			}
		} else {
			Toast.error("Invalid Token");
			navigate(RoutesService.getLoginRoute());
		}
		// if (event.key === Token_Types.ACCESS_TOKEN)
	};

	useEffect(() => {
		// Add event listener to monitor localStorage changes
		window.addEventListener("storage", handleStorageChange);

		return () => {
			// Clean up by removing the event listener
			window.removeEventListener("storage", handleStorageChange);
		};
	}, []);

	return <>{children}</>;
};

export default UserListner;
